module.exports = __webpack_public_path__ + "img/sporting-cp-logo-icon.41e1095c.png";